import { decodeHotelRoomConfig } from '../../utils/decodeHotelRoomConfig'

const getTourPackageRequestObject = ({ query }) => {
	const requestParam = {
		departureAirportCode: query.from,
		arrivalAirportCode: query.from,
		departureDate: query.date,
		passengerConfiguration: decodeHotelRoomConfig(query.travellers),
		nights: query.duration,
		nationality:
			typeof query.nationality === 'string'
				? query.nationality.toUpperCase() || 'IN'
				: 'IN',
		onwardArrivalAirportCode: 'MLE',
		returnDepartureAirportCode: 'MLE',
		topHotelsOnly: true,
	}

	return requestParam
}

export default getTourPackageRequestObject
